import { render, staticRenderFns } from "./DialogDeleteRelatorioComponent.vue?vue&type=template&id=17c12dd4&"
import script from "./DialogDeleteRelatorioComponent.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteRelatorioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports